import * as React from 'react';

import { NavLink, NavLinkProps } from 'react-router-dom';

import { Block } from 'emotion-jsxstyle';

export const SidebarNavLink: React.SFC<NavLinkProps & { onClick: () => void }> = ({ children, ...otherProps }) => {
  return (
    <Block
      props={{
        ...otherProps,
        activeClassName: 'yolo',
        activeStyle: { fontWeight: 'bold', color: '#3297d6' },
      }}
      children={children}
      component={NavLink}
      width="100%"
      css={{
        '&:active': {
          color: '#3297d6',
          textDecoration: 'none',
        },
        '&:focus': {
          color: '#3297D6',
          textDecoration: 'none',
        },
        '&:hover': {
          color: '#989EAB',
          // boxShadow: '4px 0px 0px #989EAB inset',
          textDecoration: 'none',
        },
      }}
      color="#727E96"
      transform="all 100ms ease-in"
    />
  );
};



// WEBPACK FOOTER //
// ./src/common/components/layout/Navigator/SidebarNavLink.tsx